export enum ContentTypeEnum {
    Text = 'content.text',
    RandomRecipesByCategory = 'content.recipes-by-category',
    ImageText = 'content.image-text',
}